import _implicitStylesheets from "./badge.css";
import _implicitScopedStylesheets from "./badge.scoped.css?scoped=true";
import _axBadge from "ax/badge";
import {freezeTemplate, registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element} = $api;
  return [api_custom_element("ax-badge", _axBadge, {
    props: {
      "text": $cmp.value,
      "theme": $cmp.badge.variant
    },
    key: 0
  })];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-tcmtdf9qei";
tmpl.legacyStylesheetToken = "undefined-_badge";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
